module.exports = __webpack_public_path__ + "static/media/norman-toth-177973-unsplash.fa02392d.jpg";